import LabRepository from "./LabRepository";
import { generateUrl } from "@/shared/utils";

const resource = "/instrument-instance";

export default {
  getAll(params) {
    return LabRepository.get(`${resource}?limit=all`, { params });
  },
  get(id, params) {
    return LabRepository.get(`${resource}/${id}`, { params });
  },
  create(payload) {
    return LabRepository.post(resource, payload);
  },
  update(id, payload) {
    return LabRepository.put(`${resource}/${id}`, payload);
  },
  suspend(id) {
    return LabRepository.delete(`${resource}/${id}`);
  },
  deleteBatch(payload) {
    return LabRepository.delete(resource, { data: { id: payload } });
  },
  getSamples({ id, limit, page, connections, filters, date }) {
    return LabRepository.get(
      `${resource}/${id}/scheduled-samples${
        date ? `/${date}` : ""
      }${generateUrl({ limit, page, filters, connections })}`
    );
  },
  getTasks({ id, limit, page, connections, filters, date }) {
    return LabRepository.get(
      `${resource}/${id}/scheduled-tasks${date ? `/${date}` : ""}${generateUrl({
        limit,
        page,
        filters,
        connections,
      })}`
    );
  },
};
